import React from 'react';
import {
  Box,
  Container,
  Text,
  Link,
  useColorModeValue,
  Image,
  Flex,
} from '@chakra-ui/react';

import config from '../../config/config';



/**
 * Footer component for the application
 */
const Footer = () => {
  return (
    <Box
      bg={useColorModeValue('brown.50', 'gray.900')}
      color={useColorModeValue('gray.700', 'gray.200')}
      borderTop="1px"
      borderColor={useColorModeValue('gray.200', 'gray.700')}
      py={4}
    >
      <Container maxW={'container.xl'}>
        <Flex 
          direction="column" 
          align="center"
          justify="center"
          textAlign="center"
          py={2}
        >
          <Text fontSize={'sm'} mb={2}>
            © {new Date().getFullYear()} {config.app.name}. جميع الحقوق محفوظة
          </Text>
          
          <Flex align="center" justify="center">
            <Text fontSize={'sm'} ml={2}>
              تطوير بواسطة
            </Text>
            <Link href="https://zakhm.sa" isExternal>
              <Image 
                src="/images/powerdByZakhm.svg" 
                alt="Zakhm.sa" 
                height="24px"
                fallbackSrc="https://majalisna-files-2025.s3.me-south-1.amazonaws.com/public-folder/zakhmlogo.svg"
              />
            </Link>
          </Flex>
        </Flex>
      </Container>
    </Box>
  );
};

export default Footer;
